import { useEffect, useState } from 'react';
import useStyles from './style'
import { Box, Tabs, Tab, Grid, Typography, InputBase, Button, } from '@material-ui/core';
import OrganizationalDetails from "../organizationDetails/Tabs/Details/OrganizationalDetails";
import GrantHistory from "../organizationDetails/Tabs/grantHistory/GrantHistory";
import PhotoGallery from '../organizationDetails/Tabs/photoGallery/PhotoGallery';
import ProposalDocuments from '../organizationDetails/Tabs/proposalDocuments/ProposalDocuments';
import MileStone from '../organizationDetails/Tabs/milestoneAchieved/MileStoneAchieved';
import { SearchOutlined as SearchIcon } from "@material-ui/icons";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Rating from './components/Rating';
import { PostDataAPI } from '../../../../Services/APIService';
import Breadcrumbs from '../../../../components/BreadCrums/breadcrums';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function ViewDetail({ organizationId, closeDetails, isViewingDetails, ...props }) {


    const [value, setValue] = useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [addRating, setAddRating] = useState(false);
    const Ratingodal = () => {
        setAddRating(true);
    };

    const closeAddRating = () => {
        setAddRating(false);
    };
    const handleSuccessClose = (message) => {
        setAddRating();
    }
    const classes = useStyles();

    const [donorData, setDonorData] = useState([]);

    const loadDonorDetails = () => {
        let obj = {
            donorId: organizationId
        }
        PostDataAPI("fdngrantdonor/get", obj).then((result) => {
            if (result.success && result.data != null) {
                console.log(result.data);
                setDonorData(result.data);
            }
            else {
                setDonorData([]);
            }

        })
    }


    useEffect(() => {
        loadDonorDetails();
    }, [])

    return (
        <>

            <div className={classes.header}>
                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrumbs
                            parentLink={"Organizations"}
                            currentLink={donorData?.donorName}
                            gobackAction={closeDetails}
                            isBack={true}
                        />
                    </Grid>
                </Grid>
            </div>

            <Grid container className={classes.gridHeader}>
                <Typography variant="h5" className={classes.GridHeading}>

                </Typography>
                <div className={"HeaderDialog"}>
                    {/* <div className={classes.gridActions}>
                        <Button className={classes.changeBtn}
                            onClick={() => setAddRating(true)}
                        >
                            <AddCircleOutlineIcon style={{ marginRight: "6px" }} /> Rate Ogranization
                        </Button>
                    </div> */}
                    <div className={classes.gridActions} style={{ marginRight: "7px" }}>
                      
                    </div>
                </div>
            </Grid>
            <div className={classes.content}>
                <div className={classes.tabcontainer}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                    >
                        <Tab label="Organization Details" {...a11yProps(0)} />
                        <Tab label="Grant History" {...a11yProps(1)} />
                        <Tab label="Photo Gallery" {...a11yProps(2)} />
                        <Tab label="Documents" {...a11yProps(3)} />

                    </Tabs>

                    <TabPanel value={value} index={0}>
                        <OrganizationalDetails organizationId={organizationId} />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <GrantHistory organizationId={organizationId} />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <PhotoGallery organizationId={organizationId} />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <ProposalDocuments organizationId={organizationId} />
                    </TabPanel>

                </div>


            </div>
            {addRating ? (
                <Rating
                    dialogOpenClose={Ratingodal}
                    handleClose={closeAddRating}
                    handleSuccessClose={handleSuccessClose}
                // editProgram={editData} // Conditionally pass EditProgram
                ></Rating>
            ) : (
                ""
            )}
        </>
    )
}

export default ViewDetail;